import { render, staticRenderFns } from "./NewsFilterSelect.vue?vue&type=template&id=41ade09a&"
import script from "./NewsFilterSelect.vue?vue&type=script&lang=js&"
export * from "./NewsFilterSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('41ade09a', component.options)
    } else {
      api.reload('41ade09a', component.options)
    }
    module.hot.accept("./NewsFilterSelect.vue?vue&type=template&id=41ade09a&", function () {
      api.rerender('41ade09a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/news/news-filter/NewsFilterSelect.vue"
export default component.exports